<template>
  <main>
    <section class="fk-contents">
      <div class="mod-selected-store">
        <span class="label">{{$t('Cart.ReceiveStore')}}</span>
        <div class="mod-selected-store-wrap mb15">
          <div class="mod-selected-store-name">
            <img :src="selectStore.image_url" alt="First Kitchen"><span class="name">{{selectStore.store_name}}</span>
          </div>
        </div>
      </div>

      <div class="fk-select-menu">
        <h2 class="title-lv2 mb20">{{$t('ReceiveMethod.CanOrderMenu')}}</h2>
        <ul class="select-menu">
          <li :class="morningButton === true ? 'checked' : 'disabled'">
            <div class="btn-base btn-sub">
              <span class="name morning">{{$t('ReceiveMethod.Morning')}}</span>
              <span class="exclude" v-if="!morningButton">{{$t('General.NoHandling')}}</span>
              <span class="time">{{model.openingHour.morning}}</span>
            </div>
          </li>
          <li :class="grandButton === true ? 'checked' : 'disabled'">
            <div class="btn-base btn-sub">
              <span class="name grand">{{$t('ReceiveMethod.Grand')}}</span>
              <span class="exclude" v-if="!grandButton">{{$t('General.NoHandling')}}</span>
              <span class="time">{{model.openingHour.grand}}</span>
            </div>
          </li>
        </ul>
      </div>

      <div class="fk-select-receive">
        <h2 class="title-lv2 mb20">{{$t('ReceiveMethod.Select')}}</h2>
        <p class="mod-form-btn"><a href="#" class="btn-base btn-sub has-icon shop" @click.prevent="executeSelect($event, '2')" :ref="2">{{$t('ReceiveMethod.InStore2')}}</a></p>
        <p class="mod-form-btn"><a href="#" class="btn-base btn-sub has-icon takeout" @click.prevent="executeSelect($event, '1')">{{$t('ReceiveMethod.Takeout')}}</a></p>
      </div>
    </section>
  </main>
</template>

<script>
import {get, isEmpty, assign} from 'lodash'
import CommonMixin from '@/mixins/CommonMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
import StoreUtilMixin from '@/mixins/StoreUtilMixin'
// import { appconfig } from '@/lib/appconfig'
export default {
  name: 'FKMOReceiveMethod',
  mixins: [ CommonMixin, DisplayErrorMixin, StoreUtilMixin ],
  data () {
    return {
      selectStore: {
        'store_cd': null,
        'store_name': null,
        'opening_time': null,
        'closing_time': null,
        'morning_start_time': null,
        'morning_end_time': null,
        'grand_start_time': null,
        'lastorder_time': null,
        'has_morning_menu': false,
        address: null,
        tel: null,
        latitude: null,
        longitude: null,
        services: null,
        'image_url': null,
        outputs: {
          openingTime: null,
          morningTime: null,
          closingTime: null
        }
      },
      serverTime: null,
      morningButton: false,
      grandButton: false,
      // change: false,
      timer: null,
      model: {
        openingHour: {
          morning: null,
          grand: null
        }
      }
    }
  },
  watch: {
    'getIsAcceptingMenu' (isAcceptingMenu) {
      this.morningButton = isAcceptingMenu.morning
      this.grandButton = isAcceptingMenu.grand
    },
    'getSelectStore' (store) {
      this.selectStore = store
      this.init()
    }
  },
  computed: {
    getSelectStore () {
      return this.$store.getters.selectStore
    },
    getServerTime () {
      return this.$store.getters.serverTime
    },
    getIsOpen () {
      return this.$store.getters.isOpen
    },
    getIsAcceptingMenu () {
      return this.$store.getters.isAcceptingMenu
    },
    getIsInitComplete () {
      return this.$store.getters.isInitComplete
    },
    getCart () {
      return this.$store.getters.cart
    }
  },
  methods: {
    executeSelect: function (event, id) {
      // FKMOの初期化が完了していな時はボタンを押下しても反応しない
      if (!this.getIsInitComplete) {
        return false
      }

      // 営業時間外チェック
      if (!this.getIsOpen) {
        window.commonAlert(this.$i18n.t('ErrorMsg.ERR_012'))
        return false
      }
      // 注文受付時間外のチェック
      if (!this.morningButton && !this.grandButton) {
        window.commonAlert(this.$i18n.t('ErrorMsg.ERR_011'))
        return false
      }

      this.$store.dispatch('setReceiveMethod', id)

      const change = Boolean(sessionStorage.getItem('changeReceiveMethod'))
      sessionStorage.removeItem('changeReceiveMethod')
      if (change && this.getCart.item_list.length > 0) {
        // 受取方法変更の時
        this.resetMenuCategoryType()

        // NOTE 受け取り方法を変更する時はヒストリースタックを1つ戻してから、履歴を置き換える。
        this.$router.go(-1)
        this.$router.replace({
          name: 'Cart',
          params: { requestBlock: '1' }
        })
      } else {
        // 通常遷移の時
        this.resetMenuCategoryType()

        // NOTE 受け取り方法変更フラグが立っていてもカートが0件の場合は通常遷移とみなす
        this.$router.push({ name: 'MenuCategory' })
      }
    },
    initChange: function () {
      if (!sessionStorage.getItem('changeReceiveMethod')) {
        return false
      }
      // カートの中身が0件になっていたらカートに戻さない
      if (this.getCart.item_list.length === 0) {
        sessionStorage.removeItem('changeReceiveMethod')
        return false
      }
    },
    // 時間帯またぎ判定
    checkSpanTime: function () {
      // 店舗選択時のメニューカテゴリ種別 this.getCategory.menu_category_type
      // 現在時間帯のメニューカテゴリ種別を取得する
      let nowMenuCategoryType = null
      const cart = this.getCart
      if (this.getIsAcceptingMenu.morning) {
        nowMenuCategoryType = 1
      } else if (this.getIsAcceptingMenu.grand) {
        nowMenuCategoryType = 2
      }

      // 現在時間帯と店舗選択時のメニューカテゴリ種別を比較する
      if (nowMenuCategoryType !== cart.menu_category_type) {
        // 時間帯が異なる時はカートをクリアし、メニューカテゴリ種別を再設定する
        this.clearCart(false)
        cart.menu_category_type = nowMenuCategoryType
        sessionStorage.removeItem('changeCartNumber')
        sessionStorage.removeItem('changeReceiveMethod') // 受け取り方法変更フラグを倒す
      }
    },
    // メニューカテゴリ種別の再設定
    resetMenuCategoryType: function () {
      // NOTE 狭間の時間の扱いについて
      // モーニング→グランド、閉店時間→モーニングなど、内部で保持するisAcceptingMenuの全フラグがfalseになる時間が存在する。
      // menu_category_typeは店舗を選択した時にisAcceptingMenuの状態を見て、時間帯に応じた値を設定する。
      // isAcceptingMenuの全フラグがfalseの場合、menu_category_typeはnullになってしまう。
      // 注文確定まで動的に変更しないようになっているため、時間またぎが発生してもmenu_category_typeはnullのままであり、そのままではAPIのリクエストでエラーが返される。
      // そのため、狭間の時間に時間またぎが発生した時（menu_category_type===null）に限り、menu_category_typeを再設定する。
      if (this.getCart.menu_category_type === null) {
        this.setMenuCategoryType()
      }
    },
    checkDirectStore: function () {
      const self = this
      const storeCode = sessionStorage.getItem('directStoreCode')
      if (isEmpty(storeCode)) {
        return
      }
      // 店舗コード取得できたらセッションストレージ削除する
      sessionStorage.removeItem('directStoreCode')
      // 店舗情報取得API叩く
      self.callApi('StoreInfo',
        {
          store_cd: storeCode,
          language: sessionStorage.getItem('lang')
        }
      ).then((res) => {
        const storeInfo = get(res, 'data.value.store_info', null)
        self.$store.dispatch('setServerTime', get(res, 'data.value.server_time', null))
        if (res.data.result && storeInfo != null) {
          // 店舗変更チェック（カートのクリア処理）
          this.checkStoreCode(get(storeInfo, 'store_cd', ''))
          const outputs = self.makeDisplayInfo(storeInfo)
          assign(storeInfo, outputs)
          self.$store.commit('setSelectStore', storeInfo)
        } else {
          // 店舗ダイレクトジャンプに失敗
          self.$router.push({ name: 'Index' })
        }
      }).catch(() => {
        // 店舗ダイレクトジャンプに失敗
        self.$router.push({ name: 'Index' })
      })
    },
    // 初期化
    init: function () {
      // モーニング/グランドの選択状態を初期化
      this.morningButton = this.getIsAcceptingMenu.morning
      this.grandButton = this.getIsAcceptingMenu.grand
      // モーニング/グランドの対象時間表示制御
      if (this.getSelectStore.has_morning_menu) {
        this.model.openingHour.morning = this.getSelectStore.outputs.morningTime
      } else {
        this.model.openingHour.morning = null
      }
      this.model.openingHour.grand = this.getSelectStore.outputs.grandTime

      this.checkSpanTime()
    }
  },
  beforeMount () {
    this.selectStore = this.getSelectStore

    // 店舗情報取得
    this.serverTime = this.getServerTime

    // 変更フラグの初期化
    this.initChange()

    // 初期化
    this.init()

    // 店舗ダイレクトアクセスのチェック
    this.checkDirectStore()
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ReceiveMethod.vue